<template>
  
  <a class="clickable" @click="onClick()">
    <i class="reply icon m-r-5"></i> 
    {{ historyBack ? "Voltar" : label }}
  </a>

</template>

<script>

  export default {
    
    name: "BackButtonLink",

    data() {
      return {
        historyBack: false,
      }
    },

    props: ["label", "to"],

    created() {
      this.historyBack = (this.$route.query.historyBack && this.$route.query.historyBack == "true")
    },

    methods: {
      onClick() {
        if (this.historyBack) {
          this.$historyBack()
        } else {
          this.$router.push(this.to)
        }
      },
    },
  }

</script>